 import Alpine from 'alpinejs';

Alpine.data('initScrollExpanded', () => ({
    width: 680,
    isExpanded: false,
    maxWidth: 1280,
    minWidth: 680,
    showWelcomeMessage: false,
    onScroll: null,
    isTicking: false,
    lastScrollTop: window.pageYOffset,
    animIsFinished: false,
    windowWidth : {
        "sm": {
            width: window.innerWidth - 80,
            maxWidth: window.innerWidth - 10,
            minWidth: window.innerWidth - 80,
        },
        "md": {
            width:  window.innerWidth - 200,
            maxWidth: window.innerWidth - 10,
            minWidth: window.innerWidth - 200
        },
        "lg": {
            width: 1024 - 600,
            maxWidth: 1024,
            minWidth: 1024 - 600
        },
        "xl": {
            width: 1280 - 600,
            maxWidth: 1280,
            minWidth: 1280 - 600
        },
        "2xl": {
            width: 1550 - 600,
            maxWidth: 1550,
            minWidth: 1550 - 600
        }
    },
    init() {
        // (tes calculs de width / minWidth / maxWidth)
       
       this.startAnim();

       if (window.innerWidth < 768) {
            this.width = this.windowWidth.sm.width;
            this.maxWidth = this.windowWidth.sm.maxWidth;
            this.minWidth = this.windowWidth.sm.minWidth;
        } else if (window.innerWidth < 1024) {
            this.width = this.windowWidth.md.width;
            this.maxWidth = this.windowWidth.md.maxWidth;
            this.minWidth = this.windowWidth.md.minWidth;
        } else if (window.innerWidth < 1280) {
            this.width = this.windowWidth.lg.width;
            this.maxWidth = this.windowWidth.lg.maxWidth;
            this.minWidth = this.windowWidth.lg.minWidth;
        } else if (window.innerWidth < 1550) {
            this.width = this.windowWidth.xl.width;
            this.maxWidth = this.windowWidth.xl.maxWidth;
            this.minWidth = this.windowWidth.xl.minWidth;
        }
    },

    startAnim() {
        window.addEventListener('scroll', () => {
            if (!this.isTicking) {
                window.requestAnimationFrame(() => {
                    if (this.isExpanded) this.scrollFct();
                    this.isTicking = false;
                });
                this.isTicking = true;
            }
        });
    },

    scrollFct() {
        const currentScrollTop = window.pageYOffset;
        let deltaY = currentScrollTop - this.lastScrollTop;
        this.lastScrollTop = currentScrollTop;

        // Limiter le delta à ±50px par frame
        deltaY = Math.max(-50, Math.min(50, deltaY));

        this.width += deltaY * 1.3;
        this.width = Math.min(this.maxWidth, Math.max(this.minWidth, this.width));

        if (this.width === this.maxWidth || this.width === this.minWidth) {
            this.showWelcomeMessage = true;
            setTimeout(() => {
                this.animIsFinished = true;
            }, 300);
        }
    }
}));
